import { Flex, Spin } from 'antd';

export default function Loading() {
  return (
    <Flex align="center" justify="center" gap="middle" className="w-full h-full">
      <Spin size="large" />
    </Flex>
  );
}
